export const FIRST_TAB_SKELETON_MS = 700;

/** 僅供單一瀏覽器文件使用；不同商店、身分與資料版本不得共用分頁資料。 */
export class TabViewCache<T> {
  scope = '';
  revision = '';
  pages = new Map<string, T>();
  visits = new Map<string, { readyAt: number; shown: boolean }>();
  version = 0;
  listeners = new Set<() => void>();

  subscribe = (listener: () => void) => {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  };
  snapshot = () => this.version;
  serverSnapshot = () => 0;

  private emit() {
    this.version += 1;
    this.listeners.forEach((listener) => listener());
  }

  private identify(scope: string, revision: string) {
    if (this.scope !== scope) {
      this.pages.clear();
      this.visits.clear();
    } else if (this.revision !== revision) {
      this.pages.clear();
    }
    this.scope = scope;
    this.revision = revision;
  }

  receive(scope: string, revision: string, section: string, data: T) {
    this.identify(scope, revision);
    if (this.pages.get(section) === data) return;
    this.pages.set(section, data);
    this.emit();
  }

  start(scope: string, revision: string, section: string, now: number) {
    this.identify(scope, revision);
    if (this.visits.has(section)) return;
    this.visits.set(section, { readyAt: now + FIRST_TAB_SKELETON_MS, shown: false });
    this.emit();
  }

  show(section: string) {
    const visit = this.visits.get(section);
    if (!visit || visit.shown) return;
    visit.shown = true;
    this.emit();
  }
}
